// Data-only access limits communication features; roles still grant specials access.
export const canAccessLeasingSpecials = (user) =>
  Boolean(
    user?.id &&
      user?.accountId &&
      (user.isAdmin || user.isUserAdmin || user.roles?.isLeasing || user.roles?.isManagement),
  )
